import React, {
    Component,
    PureComponent
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '../constants';
import moment from 'moment';

import fetch from '../utils/fetch';
import awsconfig from '../awsconfig';

import Icon from '@material-ui/core/Icon';

import EnhancedTable from '../widgets/table-enhanced'
import LinkButton from '../widgets/button-link'
import ChipDetails from '../widgets/chip-details'
import InputClickEditable from '../widgets/input-click-editable'
import DropdownFilterMenu from '../widgets/dropdown-filter-menu';

import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

export const ActionsMenu = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        console.log('buttonbase onClick!')
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        console.log('handleClose!');
        e.stopPropagation();
        setAnchorEl(null);
    };

    console.log(props)

    return (
        <React.Fragment>
            <ButtonBase
                className="button button-clear"
                onClick={handleClick}
            >
                Actions
            </ButtonBase>
            <Menu
                anchorEl={anchorEl}
                key={props.accident._id}
                open={Boolean(anchorEl)}
                keepMounted={true}
                className="accident-actions"
                autoFocus={false}
                variant='selectedMenu'
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                disableScrollLock={true}
            >
                <React.Fragment>
                    <MenuItem onClick={e=>{
                        handleClose(e);
                    }}>
                        <ListItemIcon>
                            <Icon>launch</Icon>
                        </ListItemIcon>
                        <ListItemText
                            inset={false}
                            primary="Move to Department"
                            secondary="Assign this Accident to a Department"
                        />
                    </MenuItem>
                </React.Fragment>
            </Menu>
        </React.Fragment>
    )
}

export default ActionsMenu;